export const MOBILE_WIDTH_LIMIT = 767;

// Mason
export const BRICK_INCLUDE_DIV_CLASS_NAME = 'gwi-brick';

export const MASON_VARIABLE_KEY_NAME = 'GoWatchItMasonObject';

export const ANALYTICS_VARIABLE_KEY_NAME = 'GoWatchItAnalyticsObject';

export const DEFAULT_MASON_VARIABLE_NAME = 'GWIMason';

// Modal
export const BLOCKER_CLASS = 'gwi-blocker';
export const DIALOG_CLASS = 'gwi-modal-dialog';
export const CONTENT_CLASS = 'gwi-modal-content';

export const WATCHABLE_TYPES = {
  MOVIE: 'Movie',
  SHOW: 'Show',
  SEASON: 'Season',
  EPISODE: 'Episode',
};



// WEBPACK FOOTER //
// ./src/config/constants.js